export default __webpack_public_path__ + "static/media/sndeep.2a46adc5.jpeg";